module.exports = __webpack_public_path__ + "img/GBA.0701e368.svg";